import api from '@/utils/api';

/**
 * Verify user from url link
 * @param {string} token - The token of the user
 * @returns {Promise}
 */
const verifyLoginApi = (token) => api.post(`/auth/login/${token}`);

export default verifyLoginApi;
